module.exports = __webpack_public_path__ + "static/media/wireframe3.bd132712.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/FacilityManage/wireframe3.png
// module id = 167
// module chunks = 0